<template>
  <div id="viewport" class="viewport-wrapper">
    <vue-progress-bar></vue-progress-bar>
    <!--<div class="absulote top-0 left-0 py-4 px-4 text-red z-100" v-if="loading">loading...</div>-->
    <div class="viewport__controller">
      <camera-position-y-controller></camera-position-y-controller>
      <zoom-controller></zoom-controller>
      <fit-controller class="mt-6"></fit-controller>
      <!--outfit-->
      <snapshot-save-button></snapshot-save-button>
    </div>
    <div v-if="isMobile" class="poser__controller poser__controller--rotation">
      <poser-rotation-controller></poser-rotation-controller>
    </div>
    <div class="mannequin-selectors__wrapper">
      <!--<mannequin-color-selector class="mr-4"></mannequin-color-selector>-->
      <mannequins-selector class="mannequin-selectors"></mannequins-selector>
      <!--<scene-background-selector class="ml-4"></scene-background-selector>-->
    </div>

    <mesh-selector v-if="!isMobile" class="mesh-selector--floating"></mesh-selector>

  

    <!--add alpha property for manage canvas transparency-->
    <vgl-renderer id="canvas" :preserve-drawing-buffer="true" :alpha="true" camera="c" scene="scene" ref="renderer" class="canvas" antialias>
      <!--:background-color="scene.backgroundColor"-->
      <vgl-scene ref="scene"  name="scene">
        <vgl-spot-light :target="lights[0].target"
                        :color="lights[0].color"
                        :decay="lights[0].decay"
                        :intensity="lights[0].intensity"
                        :distance="lights[0].distance"
                        :position="lights[0].position"
                        :angle="lights[0].angle"></vgl-spot-light>

        <vgl-hemisphere-light ground-color="#fff"
                              color="#fff"
                              intensity="0.3"></vgl-hemisphere-light>

        <vgl-group ref="poser"
                   :position="poser.position"></vgl-group>

      </vgl-scene>

      <vgl-perspective-camera name="c"
                              ref="camera"
                              :near="camera.near"
                              :far="camera.far"
                              :fov="camera.fov"
                              :orbit-target="camera.target"
                              :position="camera.position"
      ></vgl-perspective-camera>
      <!--<vgl-perspective-camera name="c"-->
      <!--ref="camera"-->
      <!--:near="camera.near"-->
      <!--:far="camera.far"-->
      <!--:fov="camera.fov"-->
      <!--:position="vector3Factory(camera.position.x, (camera.position.y - clientY ),camera.position.z)"-->
      <!--:rotation="eulerFactory(camera.rotation.x,camera.rotation.y,camera.rotation.z)"></vgl-perspective-camera>-->

    </vgl-renderer>
  </div>
</template>

<script>
  import {
    VglRenderer,
    VglScene,
    VglPerspectiveCamera,
    VglGroup,
    VglHemisphereLight,
    // VglDirectionalLight,
    VglSpotLight,
  } from 'vue-gl';
  import { gsap } from 'gsap';
  import * as THREE from 'three';
  import { isMobile } from 'mobile-device-detect';

  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  import ZoomController from './ZoomController'
  import FitController from './FitController'
  import PoserRotationController from './PoserRotationController'
  import CameraPositionYController from './CameraPositionYController'
  import MannequinsSelector from './selectors/MannequinsSelector'
  import MeshSelector from './selectors/MeshSelector';
  import SnapshotSaveButton from './partials/SnapshotSaveButton'
  // import MannequinColorSelector from './selectors/MannequinColorSelector'
  // import SceneBackgroundSelector from './selectors/SceneBackgroundSelector'




  export default {
    name: "Viewport",
    data() {
      return {
        loading: false,
        viewport: null,
        isUserInteracting: false,
        onPointerDownMouseX: 0,
        onPointerDownMouseY: 0,
        onPointerDownLon: 0,
        onPointerDownLat: 0,
        lon: 0,
        lat: 0,
        phi: 0,
        theta: 0,
        isDolling: false,
        mouse: null,
        zoom: 0,
        raycaster: null,
        y: 90,
        x: 0,
        intersects: null,
        isMobile: isMobile
      }
    },
    components: {
      VglRenderer,
      VglScene,
      VglPerspectiveCamera,
      VglGroup,
      VglHemisphereLight,
      VglSpotLight,
      ZoomController,
      CameraPositionYController,
      MannequinsSelector,
      MeshSelector,
      PoserRotationController,
      // MannequinColorSelector,
      // SceneBackgroundSelector,
      FitController,
      SnapshotSaveButton,
    },
    watch: {
      isUserInteracting: () => {
      //  todo end rotation with inertia
      },
    },
    computed: {
      ...mapGetters([
        'canvas',
        'scene',
        'renderer',
        'lights',
      ]),
      ...mapGetters('camera',[
        'camera',
      ]),
      ...mapGetters('mannequin',[
        'poser',
        'mannequin'
      ]),
      ...mapGetters('clothes',[
        'selectedDress',
        'meshesOfDress',
        'defaultTopDress',
        'defaultBottomDress'
      ]),
      ...mapGetters('snapshots',[
        'snapshots',
      ]),
    },
    methods: {
      ...mapActions('textures',[
        'initTextures',
      ]),
      ...mapActions('fabrics',[
        'initFabrics',
      ]),
      ...mapActions([
        'initViewport',
        'setPixelRatio',
        'setSceneEnv',
        'render',
        'setInitCompleted'
      ]),
      ...mapActions('mannequin',[
        'uploadMannequin',
        'setPoserInstance',
        'updatePoserRotation',
        'initMannequins',
      ]),
      ...mapActions('camera',[
        'initCamera',
        // 'moveDolly'
      ]),
      ...mapActions('snapshots',[
        'setSnapshots',
      ]),
      ...mapActions('clothes',[
        'clothesPreloading',
      ]),
      onPointerDown(event) {

        this.y = this.camera.inst.position.y;

        if ( event.isPrimary === false ) return;

        this.isUserInteracting = true;

        this.onPointerDownMouseX = event.clientX;
        this.onPointerDownMouseY = event.clientY;

        this.onPointerDownLon = this.lon;
        this.onPointerDownLat = this.lat;

        // this.viewport.removeEventListener( 'mousemove', this.onMouseMove, false );
        document.addEventListener( 'pointermove', this.onPointerMove, false );
        document.addEventListener( 'pointerup', this.onPointerUp, false );
      },
      onPointerUp(event) {

        this.y = this.camera.inst.position.y;

        if ( event.isPrimary === false ) return;

        this.isUserInteracting = false;

        document.removeEventListener( 'pointermove', this.onPointerMove );
        document.removeEventListener( 'pointerup', this.onPointerUp );
        // this.viewport.addEventListener( 'mousemove', this.onMouseMove, false );

      },
      onPointerMove(event) {

        // console.log(this.y, this.camera.inst.position.y,this.lat);
        this.lon = ( this.onPointerDownMouseX - event.clientX ) * 0.3 + this.onPointerDownLon;
        this.lat = ( event.clientY - this.onPointerDownMouseY ) * 0.2 + this.onPointerDownLat;

        this.camera.inst.position.y = THREE.MathUtils.clamp((this.y + (( event.clientY - this.onPointerDownMouseY )*0.2)/this.camera.inst.zoom),15,165);

        this.updatePoserRotation({lat: this.lon,lon: this.lon}).then( () => {
          this.render();
        });

      },
      onViewportMouseWheel(event) {
        // event.preventDefault();

        // this.mouse.x = ( event.offsetX / event.target.width ) * 2 - 1;
        // this.mouse.y = - ( event.offsetY / event.target.height ) * 2 + 1;
        //
        // this.raycaster.setFromCamera( this.mouse, this.camera.inst );
        //
        // if(this.mannequin.type === 'drape') {
        //   let mesh = this.meshesOfDress(this.selectedDress)[0];
        //   this.intersects = this.raycaster.intersectObject( mesh );
        // } else {
        //   this.intersects = this.raycaster.intersectObject( this.mannequin.inst );
        // }
        // // this.intersects = this.raycaster.intersectObject( this.mannequin.inst );
        //
        // // this.intersects = this.raycaster.intersectObject( this.selectedDress.inst );
        //
        // if(this.intersects[0]){
        //   this.y = this.intersects[0].point.y;
        //   this.x = this.intersects[0].point.x;
        // }

        let increment = 0;
        if(event.deltaY > 0) {
          increment = -2;
          this.zoom = this.camera.inst.position.z*2;
        } else {
          increment = 2;
          this.zoom = this.camera.inst.position.z/2;
        }

        if(this.camera.inst.zoom === 1) {
          this.x = 0;
          this.y = 90;
        }

        gsap.to(this.camera.inst,{duration: 1.0, zoom: THREE.MathUtils.clamp( (this.camera.inst.zoom + increment ) ,1,10), onUpdate: () => {
            this.camera.inst.updateProjectionMatrix();
            this.render();
          } ,ease: 'sine.inOut',onComplete: () => {
            this.viewport.addEventListener( 'wheel', this.onViewportMouseWheel, { passive: true, once: true } );
          }});

        // gsap.to(this.camera.inst.position,{duration: 1.0, x: this.x, y: this.y, ease: 'sine.inOut', onUpdate: this.render, onComplete: () => {
        //   this.isDolling = false;
        //     this.viewport.addEventListener( 'wheel', this.onViewportMouseWheel, { passive: true, once: true } );
        //   } })

      },
    },
    mounted() {

      this.$Progress.start();

      this.loading = true;
      this.viewport = document.getElementById( 'viewport' );

      // console.log(isMobile);

      if(!isMobile) {
        this.viewport.addEventListener( 'pointerdown', this.onPointerDown, false );
        // this.viewport.addEventListener( 'mousemove', this.onMouseMove, false);
        this.viewport.addEventListener( 'wheel', this.onViewportMouseWheel, { passive: false, once: true } );
      }


      this.raycaster = new THREE.Raycaster();
      this.mouse = new THREE.Vector2();

      if(window.config && window.config.mannequins && window.config.fabrics && window.config.textures) {

        const config = {
          renderer: this.$refs.renderer,
          scene: this.$refs.scene.inst,
          poser: this.$refs.poser.inst,
          camera: this.$refs.camera.inst,
          pixelRatio: window.devicePixelRatio,
        }
        // console.log('init viewport');
        //inizializzo i dati che mi passa Riccardo dalla suite

        this.initViewport(config).then(() => {
          // console.log(this.$Progress);
          // console.log('init fabrics');
          return this.initFabrics(window.config.fabrics);
        }).then(() => {
          // console.log('init mannequins');
          return this.initMannequins(window.config.mannequins)
        }).then(() => {
          // console.log('init textures');
          return this.initTextures(window.config.textures);
        }).then(() => {

          if(window.config.snapshots && window.config.snapshots.length > 0) {

            this.setSnapshots(window.config.snapshots).then(() => {
              this.loading = false;
              this.$Progress.finish();
              this.setInitCompleted();
            });

          } else {
            this.loading = false;
            this.$Progress.finish();
            this.setInitCompleted();
          }

          // this.clothesPreloading();


        }).catch((e) => {
          console.error(e);
          this.$Progress.fail();
        });


      }

      // this.init();
    },
    beforeDestroy() {

      if(!isMobile) {
        this.viewport.removeEventListener( 'pointerdown', this.onPointerDown );
        this.viewport.removeEventListener( 'wheel', this.onViewportMouseWheel );
      }

      // this.viewport.removeEventListener( 'mousemove', this.onMouseMove );
    }
  }
</script>

<style scoped>
  .viewport-wrapper {
    position: relative;
    width: 100%;
    user-select: none;
  }

  .canvas {
    background-color: #fff;
    position: relative;
    pointer-events: all;
    width: 100%;
    height: 100%;
  }

  .canvas > canvas {
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: all;
  }

  .viewport__controller {
    position: absolute;
    bottom: 30px;
    right: 30px;
    z-index: 10;
  }

  .mannequin-selectors__wrapper {
    position: absolute;
    top: 15px;
    max-width: 100%;
    width: 100%;
    z-index: 50;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
  }

  .mannequin-selectors {
    width: max-content;
    /*margin: 0 auto;*/
    /*min-width: 100%;*/
  }

  .mesh-selector--floating {
    position: absolute;
    z-index: 10;
    top: 90px;
    left: 30px;
    max-width: 200px;
  }

  .poser__controller--rotation {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-65px);
    z-index: 10;
  }

  @media only screen and (max-width: 1024px) {

    .viewport__controller {
      position: absolute;
      bottom: 100px;
      right: 20px;
      z-index: 10;
    }

    .poser__controller--rotation {
      bottom: 90px;
      left: 50%;
    }

  }

</style>